<template>
  <div>
    <px-view-header title="Produtos" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-produtos-list-header :on-click-refresh="onClickRefresh"
                             :on-change-filter="onChangeFilter" />
    <px-produtos-list :produtos="produtos"
                      :loading="loading"
                      :on-change-options="onChangeOptions"
                      :options-list="optionsList"
                      @remove="onRemove" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import paginationMixin from '@/mixins/pagination-mixin';
import ProdutosList from './listagem/ProdutosList.vue';
import ProdutosListHeader from './listagem/ProdutosListHeader.vue';
import ProdutoService from './service/produtos-service';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      loading: false,
      empresa: null,
      breadcrumbs: [
        { text: 'Produtos' },
        { text: 'Meus produtos' },
      ],
      produtos: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: 'entidade is not null',
        sort: 'descricao',
        sortDesc: false,
      },
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemProdutos', ['stringFilter']),
  },
  methods: {
    onChangeFilter() {
      this.listOptions.filter = this.stringFilter;
      this.resetPage();
      this.getProdutos();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getProdutos();
    },
    onClickRefresh() {
      this.getProdutos();
    },
    onRemove(item) {
      this.loading = true;
      ProdutoService.remover(item.id)
        .then(() => {
          this.$toast('Produto removido com sucesso', { color: 'success' });
          this.getProdutos();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getProdutos() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return ProdutoService.getList({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.produtos = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.listOptions.filter = this.stringFilter;
  },
  components: {
    pxProdutosList: ProdutosList,
    pxProdutosListHeader: ProdutosListHeader,
  },
};
</script>
